module.exports = __webpack_public_path__ + "static/media/5.14764a09.JPG";